<template>
    <el-card class="el-card-blank" shadow="never">
        <template #header>
            Muokkaa kaikkia alla olevia huonekortteja
        </template>
        <el-form :inline="true" label-position="top">
            <el-form-item label="Henkilömäärä norm." prop="henkilomaaraNorm">
                <el-input-number :min="0" size="small" v-model="huonekortti.henkilomaaraNorm" style="width: 100%" />
            </el-form-item>
            <el-form-item label="Henkilömäärä max" prop="henkilomaaraMax">
                <el-input-number :min="0" size="small" v-model="huonekortti.henkilomaaraMax" style="width: 100%" />
            </el-form-item>
            <el-form-item label="Toiminta-aika" prop="toimintaAika">
                <el-select
                    allow-create
                    filterable
                    placeholder="Valitse tai kirjoita"
                    size="small"
                    v-model="huonekortti.toimintaAika"
                    style="width: 200px">
                    <el-option
                        v-for="item in toimintaAika"
                        :key="item"
                        :label="item"
                        :value="item" />
                </el-select>
            </el-form-item>
            <el-form-item label="Sähköluokka" prop="sahkoluokka">
                <el-select
                    v-model="huonekortti.sahkoluokka"
                    placeholder="Valitse sähköluokka"
                    size="small"
                    style="width: 180px">
                    <el-option
                        v-for="luokka in sahkoluokat"
                        :key="luokka"
                        :label="luokka"
                        :value="luokka" />
                </el-select>
            </el-form-item>
            <el-form-item label="&nbsp;">
                <el-button type="success" @click="ylikirjoita" size="small">Ylikirjoita</el-button>
            </el-form-item>
        </el-form>
    </el-card>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { HuonekorttiResponse } from '@/api/models/huonekortti-response';
import { HuonekorttiSahkoluokka } from '@/api/models/huonekortti-sahkoluokka';
import ToimintaAika from '@/types/ToimintaAikaEnum';
import { useHuonekorttiMuokkausComponent } from './huonekorttiMuokkaus';

const huonekortti = ref<HuonekorttiResponse>({} as HuonekorttiResponse)
const sahkoluokat = Object.values(HuonekorttiSahkoluokka)
const toimintaAika = ToimintaAika
const { overwriteHuonekortit } = useHuonekorttiMuokkausComponent()

const ylikirjoita = () => {
    overwriteHuonekortit(huonekortti.value)
    huonekortti.value = {} as HuonekorttiResponse
}

</script>
